import React, { PropTypes, Component } from 'react';
import TwoColumnRow from '../../../../tc-ui/two-column-row';
import { connect } from 'react-redux';
import {
  Divider,
  Table,
  TableHeader,
  TableHeaderColumn,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui';
import EditButton from '../../../generic-components/edit-button';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import DateUtils from '../../../../../utils/date-utils';
import HelperLink from '../helper-link';
import EditSeasonButton from '../edit-season-button';
import R from 'ramda';

const propTypes = {
  allocation: PropTypes.array,
  productType: PropTypes.string,
  existingSeasons: PropTypes.array,
  openAddEditContractDialog: PropTypes.func,
  supplierEditable: PropTypes.bool,
  classes: PropTypes.object,
};

class RightOne extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }

  render() {
    const {
      allocation,
      productType,
      openAddEditContractDialog,
      supplierEditable,
      existingSeasons = [],
      classes = {},
    } = this.props;

    const getAllocation = {
      onRequest: 'On Request',
      freesale: 'Freesale',
      allotment: 'Allotment',
    };
    if (!(allocation && allocation.length)) {
      return (
        <div style={{ marginBottom: '12px' }} id="allocation">
          <HelperLink value="allocation" labelStyle={{ marginBottom: '12px' }}>
            ALLOCATION
          </HelperLink>
          <AddItemCard
            text="Add allocation information"
            onClick={() =>
              openAddEditContractDialog({ type: 'allocation', title: 'Add Allocation' })
            }
            editable={supplierEditable}
          />
        </div>
      );
    }
    const varyBySeason =
      allocation &&
      allocation.length &&
      (allocation.length > 1 || R.path([0, 'dateRanges', 'length'], allocation) > 1);
    const editAllocationFn = () =>
      openAddEditContractDialog({ type: 'allocation', title: 'Edit Allocation' });
    return (
      <div id="allocation" className={classes['main']}>
        <MouseOverEditDiv
          editable={supplierEditable}
          hintOnRight
          singleLineTitle
          regularDiv={
            allocation.length > 1 &&
            R.any(R.compose(R.isEmpty, R.prop('dateRanges')), existingSeasons)
          }
          actionButtons={<EditButton onEdit={editAllocationFn} />}
        >
          <HelperLink value="allocation" labelStyle={{ marginBottom: '12px' }}>
            <b>ALLOCATION</b>
          </HelperLink>
          {allocation.map(
            ({ allocationType, allotments, releaseBackDays, numberOfRooms, ...extraAlloProps }, index) => {
              const { dateRanges } =
                (allocation.length > 1 && existingSeasons.length
                  ? existingSeasons[index]
                  : extraAlloProps) || { dateRanges: [] };
              return (
                <div key={index} className={classes[`${index}-allocation`]}>
                  <TwoColumnRow
                    outerContainerStyle={{
                      marginBottom: '0',
                      backgroundColor: 'rgba(0, 0, 0, 0.1)',
                      borderLeft: '1px solid #bababa',
                      borderBottom: '1px solid #bababa',
                      borderRight: '1px solid #bababa',
                      borderTop: !index ? '1px solid #bababa' : '',
                    }}
                    leftColumnStyle={{ color: '#262626', padding: '4px 8px' }}
                    rightColumnStyle={{ color: '#262626', padding: '4px 8px' }}
                    rightColumnClassName={classes[`${index}-allocationType`]}
                    leftColumnContent={
                      <div style={{ fontSize: '12px' }}>
                        <div style={{ color: '#f44336' }}>
                          {varyBySeason &&
                          existingSeasons.length &&
                          !DateUtils.getSeasonNameIfMatch(existingSeasons, dateRanges || [])
                            ? `These dates don't match any seasons.`
                            : ''}
                        </div>
                        {R.isEmpty(dateRanges) && R.length(allocation) > 1 && supplierEditable ? (
                          <EditSeasonButton
                            existingSeasons={existingSeasons}
                            openAddEditContractDialog={openAddEditContractDialog}
                            seasonRatesIndex={index}
                            seasonName={R.path([index, 'seasonName'], existingSeasons)}
                            dateRanges={dateRanges}
                          />
                        ) : (
                          <div>
                            {(dateRanges || []).map((range, rangeIndex) => {
                              return (
                                <div
                                  key={rangeIndex}
                                  className={classes[`${index}-dateRanges-${rangeIndex}`]}
                                >
                                  {DateUtils.displayRange(range, {
                                    start:
                                      classes[`${index}-dateRanges-${rangeIndex}-seasonStartDate`],
                                    end: classes[`${index}-dateRanges-${rangeIndex}-seasonEndDate`],
                                  })}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    }
                    rightColumnContent={getAllocation[allocationType]}
                  />
                  {allocationType === 'allotment' ? (
                    <div
                      style={{
                        borderLeft: '1px solid #bababa',
                        borderBottom: '1px solid #bababa',
                        borderRight: '1px solid #bababa',
                      }}
                    >
                      <Table>
                        <TableHeader
                          displaySelectAll={false}
                          adjustForCheckbox={false}
                          style={{ borderBottom: '' }}
                        >
                          <TableRow displayBorder={false} style={{ height: '32px' }}>
                            <TableHeaderColumn
                              style={{ paddingLeft: '8px', height: '32px', textAlign: 'center' }}
                            >
                              {productType && productType === 'Non-Accommodation'
                                ? 'Number of Passengers'
                                : 'Number of Rooms'}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              style={{ paddingLeft: '16px', height: '32px', textAlign: 'center' }}
                            >
                              Release Back Days
                            </TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                          {allotments.map((allotment, i) => (
                            <TableRow
                              key={i}
                              style={{ height: '32px' }}
                              displayBorder={false}
                              className={classes[`${index}-allotments-${i}`]}
                            >
                              <TableRowColumn
                                style={{
                                  textAlign: 'center',
                                  paddingLeft: '0',
                                  height: '32px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                }}
                                className={classes[`${index}-allotments-${i}-numberOfRooms`]}
                              >
                                {allotment.numberOfRooms}
                              </TableRowColumn>
                              <TableRowColumn
                                style={{
                                  textAlign: 'center',
                                  height: '32px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                }}
                                className={classes[`${index}-allotments-${i}-releaseBackDays`]}
                              >
                                {allotment.releaseBackDays}
                              </TableRowColumn>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  ) : undefined}
                  {allocationType === 'freesale' && !numberOfRooms ? (
                    <div
                      style={{
                        borderLeft: '1px solid #bababa',
                        borderBottom: '1px solid #bababa',
                        borderRight: '1px solid #bababa',
                      }}
                    >
                      <TwoColumnRow
                        key={index}
                        outerContainerStyle={{ marginBottom: '8px', paddingTop: '8px' }}
                        leftColumnStyle={{
                          float: 'left',
                          fontSize: '12px',
                          color: '#9e9e9e',
                          paddingLeft: '8px',
                        }}
                        leftColumnContent="Release Back Days"
                        rightColumnStyle={{
                          float: 'right',
                          paddingRight: '26px',
                          fontWeight: 'bold',
                          color: 'black',
                        }}
                        rightColumnClassName={classes[`${index}-releaseBackDays`]}
                        rightColumnContent={releaseBackDays}
                      />
                    </div>
                  ) : undefined}
                  {allocationType === 'freesale' && numberOfRooms ? (
                    <div
                      style={{
                        borderLeft: '1px solid #bababa',
                        borderBottom: '1px solid #bababa',
                        borderRight: '1px solid #bababa',
                      }}
                    >
                      <Table>
                        <TableHeader
                          displaySelectAll={false}
                          adjustForCheckbox={false}
                          style={{ borderBottom: '' }}
                        >
                          <TableRow displayBorder={false} style={{ height: '32px' }}>
                            <TableHeaderColumn
                              style={{ paddingLeft: '8px', height: '32px', textAlign: 'center' }}
                            >
                              {productType && productType === 'Non-Accommodation'
                                ? 'Number of Passengers'
                                : 'Number of Rooms'}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              style={{ paddingLeft: '16px', height: '32px', textAlign: 'center' }}
                            >
                              Release Back Days
                            </TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                          <TableRow
                            style={{ height: '32px' }}
                            displayBorder={false}
                            className={classes[`${index}-freesale`]}
                          >
                            <TableRowColumn
                              style={{
                                textAlign: 'center',
                                paddingLeft: '0',
                                height: '32px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                              }}
                              className={classes[`${index}-numberOfRooms`]}
                            >
                              {numberOfRooms}
                            </TableRowColumn>
                            <TableRowColumn
                              style={{
                                textAlign: 'center',
                                height: '32px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                              }}
                              className={classes[`${index}-releaseBackDays`]}
                            >
                              {releaseBackDays}
                            </TableRowColumn>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </div>
                  ) : undefined}
                </div>
              );
            },
          )}
        </MouseOverEditDiv>
        <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />
      </div>
    );
  }
}

RightOne.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { allocation }) => {
  if (allocation) return { allocation };
  return {
    allocation: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'allocation'])
      ? contracting.contractActivitiesProducts.getIn(['rightSideContent', 'allocation']).toJS()
      : [],
  };
};
export default connect(mapStateToProps)(RightOne);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/right-one.jsx